/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ExternalNexonLwControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public getIndicator({
        filter,
    }: {
        filter: 'CIRCULATING_SUPPLY' | 'TOTAL_SUPPLY',
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/external/nexon/livewatch/indicator',
            query: {
                'filter': filter,
            },
        });
    }

}
